import React, { useContext, useEffect } from 'react';

import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Row, Col } from 'react-bootstrap';

import Footer from '../Containers/Footer';
import AppContext from '../App.context';
// import DataSource from '../../config/api';
import TestDetails from './TestDetails';
// import DefaultLoader from './DefaultLoader';

import '../../style/appointmentConfirmation.css';
import ConstUtils from '../../config/constants';

export default function ConfirmationPage() {

  const history = useHistory();
  const location = useLocation();
  const { setEntityDetails } = useContext(AppContext);

  // const [isLoading, setIsLoading] = useState(false);
  // const [updateAppointmentError, setUpdateAppointmentError] = useState('');

  const { address, requestId, slotDetails, caseDetails, showAddress, landedFromAppointmentPage } = location.state || {};

  useEffect(() => {
    setEntityDetails({
      insurerId: caseDetails?.EntityRelationId,
      insurerName: caseDetails?.insuranceCompanyName
    });
  }, []);

  const requiredParams = ["address", "requestId", "slotDetails", "caseDetails", "showAddress"];
  const missingParams = requiredParams.filter(param => location.state?.[param] == null);

  if (missingParams.length > 0 || landedFromAppointmentPage === null) {
    history.push('/404');
  }

  const getCalenderUrl = () => {
    const dateString = convertDateFormat(slotDetails.appointmentDate);
    const formattedDate = new Date(dateString).toISOString().replace(/[-:]/g, "").replace(".000Z", "Z");
    return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent("Appointment Details")}&details=${encodeURIComponent("details")}&location=${encodeURIComponent(address)}&dates=${formattedDate}/${formattedDate}`;
  }

  const convertDateFormat = (dateString) => {
    const dateArr = dateString.split("-");
    const timeArr = slotDetails.appointmentTime.split(" ");

    let day = landedFromAppointmentPage ? dateArr[2] : dateArr[0];
    let month = dateArr[1];
    let year = landedFromAppointmentPage ? dateArr[0] : dateArr[2];

    if (parseInt(month) < 10 && month[0] !== "0") {
      month = `0${month}`;
    }
    if (parseInt(day) < 10 && day[0] !== "0") {
      day = `0${day}`;
    }

    const time = timeArr[0].padStart(5, "0") + ":00";

    const formattedDate = `${year}-${month}-${day}T${time}`;
    return formattedDate;
  }

  // const updateAppointment = async () => {
  //   setIsLoading(true);
  //   try {
  //     const response = await DataSource.generateSal({
  //       type: "GENERIC_PROD",
  //       requestId: requestId,
  //       isReschedule: true,
  //       utm_mode: "SMS",
  //       utm_actor: "Customer",
  //       utm_trigger: "Reschedule",
  //       utm_fcount: ""
  //     });

  //     if (response.data.success) {
  //       try {
  //         window.location.href = response.data.url;
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     } else {
  //       setUpdateAppointmentError('Error occured');
  //     }
  //   } catch (error) {
  //     setUpdateAppointmentError('Error occured catch');
  //   }
  //   setIsLoading(false);
  // };

  return (
    <>
      {
        slotDetails && caseDetails ?
          <div>
            {/* {isLoading && (
              <div className='custom-loader'>
                <DefaultLoader />
              </div>
            )} */}
            <div className='confirmation'>
              <Row>
                <Col xs={12} sm={12} md={7} lg={8}>
                  <div className='confirmation-header'>
                    <img src={`${ConstUtils.StaticS3ImageUrl}/TickIcon.svg`} alt='' />
                    <div style={{ padding: '24px' }}>
                      <h5 style={{ fontFamily: 'Lexend Deca', marginBottom: '12px' }}>Request received</h5>
                      <span>Confirmation details will be sent 1 day before the appointment date</span>
                    </div>
                  </div>

                  <div className='confirmation-body'>
                    <Row className='confirmation-body-details'>
                      <Col xs={6} md={6} lg={3} className='confirmation-body-details-label'>Reference Number:</Col>
                      <Col xs={6} md={6} lg={9} className='confirmation-body-details-value'>{requestId}</Col>
                    </Row>
                    <Row className='confirmation-body-details'>
                      <Col xs={6} md={6} lg={3} className='confirmation-body-details-label'>Name:</Col>
                      <Col xs={6} md={6} lg={9} className='confirmation-body-details-value'>{caseDetails?.policyBuyerName}</Col>
                    </Row>
                    <Row className='confirmation-body-details'>
                      <Col xs={6} md={6} lg={3} className='confirmation-body-details-label'>Slot Details:</Col>
                      <Col xs={6} md={6} lg={9} className='confirmation-body-details-value'>
                        <span>{`${slotDetails.appointmentDate}, ${slotDetails.appointmentTime}`}</span>
                        <div>
                          <a className='confirmation-body-details-calendar' target='_blank' href={getCalenderUrl()} rel="noopener noreferrer">
                            Add to Calendar &nbsp; <img src={`${ConstUtils.StaticS3ImageUrl}/Calendar.svg`} alt='' />
                          </a>
                        </div>
                      </Col>
                    </Row>
                    {
                      showAddress &&
                      <Row className='confirmation-body-details'>
                        <Col xs={6} md={6} lg={3} className='confirmation-body-details-label'>Appointment Address:</Col>
                        <Col xs={6} md={6} lg={9} className='confirmation-body-details-value'>{address}</Col>
                      </Row>
                    }
                  </div>
                </Col>

                <Col xs={12} sm={12} md={5} lg={4}>
                  <TestDetails
                    caseData={caseDetails}
                  />
                </Col>
              </Row>

              {/* {
                landedFromAppointmentPage &&
                <Row>
                  <Col xs={12} sm={12} md={7} lg={8}>
                    <div className='modify-appointment'>
                      {window.innerWidth >= 576 && <span>Need to make changes to your booking?</span>}
                      <button onClick={() => updateAppointment()}>Modify Appointment</button>
                    </div>
                  </Col>
                </Row>
              } */}

              {/* {
                updateAppointmentError &&
                <Row>
                  <Col xs={12} sm={12} md={7} lg={8}>
                    <span className='text-danger mt-2'>{updateAppointmentError}</span>
                  </Col>
                </Row>
              } */}
            </div>
            <Footer
              isFooterFixed={window.innerWidth >= 768 ? true : false}
            />
          </div> : null
      }
    </>
  );
}